<template>
  <div class="pointer-events-none fixed top-0 left-0 flex h-full w-5/6">
    <button
      class="bg-ontick-carbon-900 active:bg-ontick-carbon-900 pointer-events-auto fixed inset-0 h-full w-full opacity-75"
      v-if="isOpen"
      @click="toggleIsOpen"
    >
      <span class="sr-only">Fechar menu</span>
    </button>
    <button
      v-if="!isOpen"
      @click="toggleIsOpen"
      class="bg-ontick-steel-100 text-ontick-carbon-900 dark:bg-ontick-steel-800 pointer-events-auto flex h-full w-5 items-center justify-center shadow-lg dark:text-gray-300"
    >
      <i v-html="$icons.chevron_right"></i>
    </button>
    <transition name="slide-in">
      <account-menu-component
        v-if="isOpen"
        :data="data"
        :tabActive="tabActive"
        isMobile
        @close="toggleIsOpen"
        @active-tab="$emit('active-tab', $event)"
      />
    </transition>
  </div>
</template>

<script>
import AccountMenuComponent from "./account-menu.component.vue";
import socialLinksComponent from "./social-links.component.vue";
export default {
  components: { socialLinksComponent, AccountMenuComponent },
  props: {
    data: {
      type: Array,
    },
    tabActive: {
      type: String,
      default: "profile",
    },
  },
  data() {
    return {
      isOpen: false,
    };
  },
  methods: {
    toggleIsOpen() {
      this.isOpen = !this.isOpen;
    },
  },
};
</script>

<style lang="scss" scoped>
.slide-in {
  &-enter-active,
  &-leave-active {
    @apply transition-all duration-300 ease-in-out;
  }
  &-enter, &-leave-to /* .fade-leave-active below version 2.1.8 */ {
    @apply -translate-x-full transform opacity-0;
  }
}
</style>
